import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { getSSOCallbackOverrideUrl } from 'features/sso/utils';
import { Yup } from 'shared/yup-extended';

type SSORequiredResponse = {
  ssoRequired: boolean;
  loginUrl?: string;
};

const fetchSSORequired = async (
  email: string,
): Promise<SSORequiredResponse> => {
  const response = await API.get(`/organization/sso/required/`, {
    params: { email, callbackUrl: getSSOCallbackOverrideUrl() },
  });
  return response.data;
};

export type UseSSORequired = Omit<
  UseQueryResult<SSORequiredResponse, Error>,
  'data'
> & {
  ssoRequired?: boolean;
  loginUrl?: string;
};

export const useSSORequired = (email: string): UseSSORequired => {
  const { data, ...results } = useQuery<SSORequiredResponse>({
    queryKey: ['ssoRequired', email],
    queryFn: () => fetchSSORequired(email),
    enabled: Boolean(
      email && Yup.string().email().validTLD().isValidSync(email),
    ),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return {
    ...results,
    ssoRequired: Boolean(data?.ssoRequired),
    loginUrl: data?.loginUrl,
  };
};
